import Designer from './designer/Designer';
import SimpleFormController from './simple-form/SimpleFormController.js';

/**
 * Initialize Advanced Designer functionality
 */
function attachDesigner(){
    const designerButton = document.querySelector('.customize-card');

    if (!designerButton) return false;

    // Parse templates data
    let templates = [];
    try {
        templates = JSON.parse(designerButton.dataset.templates || '[]');
    } catch (error) {
        console.error('Error parsing templates data:', error);
    }

    new Designer(designerButton, {
        basePrice: parseFloat(designerButton.dataset.basePrice || '30.00'),
        templates: templates,
        defaultTemplate: parseInt(designerButton.dataset.defaultTemplate || '0', 10)
    });

    return true;
}

/**
 * Initialize Simple Form functionality
 */
function attachSimpleForm() {
    const simpleForm = document.querySelector('#stc-simple-form');
    
    if (!simpleForm) return false;
    
    try {
        new SimpleFormController(simpleForm, {
            templateId: window.stcTemplateId || 0,
            basePrice: parseFloat(window.stcBasePrice || 0),
            nonce: window.octStcCustomizer?.nonce || ''
        });
        
        console.log('Simple form controller initialized successfully');
        return true;
        
    } catch (error) {
        console.error('Error initializing simple form:', error);
        return false;
    }
}

/**
 * Initialize all functionality
 */
function initializeAll() {
    // Check if we're on a trading card product page
    if (!document.querySelector('.trading-card-product-form')) {
        return;
    }

    console.log('Initializing trading card functionality...');

    // Initialize simple form (always present)
    const simpleFormInitialized = attachSimpleForm();

    // Initialize advanced designer (desktop only)
    const designerInitialized = attachDesigner();

    console.log('Initialization complete:', {
        simpleForm: simpleFormInitialized,
        designer: designerInitialized
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
} else {
    initializeAll();
}